import { useResponseHandlerService } from '../services';
import { useAuth0 } from '@auth0/auth0-react';
import * as Sentry from "@sentry/react";
const { fetch: originalFetch } = window;

export function useErrorHandlerInterceptor() {
	const { addError } = useResponseHandlerService();
	const { logout } = useAuth0();

	const logoutWithRedirect = () =>
		logout({
			returnTo: `${window.location.origin}/admin`,
		});


	window.fetch = async (...args) => {
		let [resource, config] = args;
		let response;
		try {
			response = await originalFetch(resource, config);
		} catch (err) {
			Sentry.captureException(err);
			return Promise.reject(err);
		}
		
		if (!response.ok) {
			try {
				const responseBody = await response.json();
				switch (response.status) {
					case 404:
						addError(new Error('NotFound'));
						break;
					case 401:
						addError(new Error('Unauthorized'));
						logoutWithRedirect();
						break;
					default:
						addError(new Error(responseBody.message));
				}
			} catch (e) {
				console.error(e);
			}
			return Promise.reject(response);
		}
		return response;
	};
	return;
}
